<div id="page-container">
  <div id="hash-container" class="flex flex-row gap-10 align-items-start">
    <img src="assets/hash-icon.svg" class="icon-inline">
    <div class="flex flex-column">
      <h1 class="light-blue text-lg no-margin">JOURNAL D'AUDIT</h1>
      <p class="grey text-sm no-margin">Ce journal retrace les actions réalisées pendant le scrutin, et en garantissant l'intégrité</p>
    </div>
  </div>

  <div class="hash-filters flex flex-row gap-10 align-items-center" style="width: 100%">
    <img src="assets/filters-icon.svg" class="icon-inline" style="margin-left: 41px;">
    <p class="dark-blue text-sm">Type :</p>
    <select id="audit-mode" name="audit-mode" [(ngModel)]="filterValue" (ngModelChange)="onFilterChange()">
      <option value="tous">Tous</option>
      <option value="creation">{{formatTypeAction('creation')}}</option>
      <option value="sealing">{{formatTypeAction("sealing")}}</option>
      <option value="changeMail">{{formatTypeAction("changeMail")}}</option>
      <option value="changeMailA">{{formatTypeAction("changeMailA")}}</option>
      <option value="opening">{{formatTypeAction("opening")}}</option>
      <option value="assessorSuspend">{{formatTypeAction("assessorSuspend")}}</option>
      <option value="suspension">{{formatTypeAction("suspension")}}</option>
      <option value="relaunch">{{formatTypeAction("relaunch")}}</option>
      <option value="unsealing">{{formatTypeAction("unsealing")}}</option>
      <option value="closing">{{formatTypeAction("closing")}}</option>
    </select>
    <img src="assets/filters-icon.svg" class="icon-inline" style="margin-left: 41px;">
    <p class="dark-blue text-sm">Cible :</p>
    <select id="target-select" name="target-select" [(ngModel)]="targetValue" (ngModelChange)="onFilterChange()">
      <option value="tous">Tous</option>
      <option value="election">{{formatTargetLine('election')}}</option>
      <option value="voters">{{formatTargetLine("voters")}}</option>
      <option value="assessors">{{formatTargetLine("assessors")}}</option>
    </select>
    <button class="flex align-items-center flex-row" id="download-report" style="margin-left: 41px" (click)="downloadReport()"><img
      src="assets/download-icon.svg" class="icon-inline">Télécharger le rapport</button>
  </div>

  <div>
    <p-table [value]="filteredAuditLines" [tableStyle]="{'width': '100%'}" styleClass="p-datatable-striped" [paginator]="true" [rows]="5">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="time" style="width:23%">
            Date / Heures <p-sortIcon field="time" />
          </th>
          <th pSortableColumn="userEmail" style="width:20%">
            Utilisateur <p-sortIcon field="userEmail" />
          </th>
          <th pSortableColumn="type" style="width:18%">
            Type d'action <p-sortIcon field="type" />
          </th>
          <th pSortableColumn="target" style="width:19%">
            Cible <p-sortIcon field="target" />
          </th>
          <th pSortableColumn="hashComparison" style="width:13%">
            Résultat <p-sortIcon field="hashComparison" />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-audit>
        <tr>
          <td>{{ formatDate(audit.time) }}</td>
          <td>{{ audit.userEmail }}</td>
          <td>{{ formatTypeAction(audit.type) }}</td>
          <td>{{ formatTargetLine(audit.target) }}</td>
          <td class="flex align-items-center" [ngClass]="'green'"><span
              id="bullet" class="rounded mr-5" [ngClass]="'bg-green'"></span>Succès</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="flex flex-column gap-10 content-center align-items-center">
    <p class="grey text-sm align-items-center">Ce journal est signé numériquement pour garantir son intégrité</p>
  </div>
</div>
